@for (option of options.options; track option) {
  <div
    class="option"
    [innerText]="option.name"
    [class.active]="option.selected"
    (click)="onClick(option)"
  ></div>
}
